import { Fragment, useState } from "react";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConfirmDialog, { ConfirmDialogProps } from "./dialog";

import ActionBarButton from "../ActionBarButton";

type WithConfirm = {
  withConfirm: true;
  ConfirmDialogProps: Omit<ConfirmDialogProps, "onConfirm">;
};
type WithoutConfirm = {
  withConfirm?: undefined | false;
  ConfirmDialogProps?: undefined;
};
type DeleteButtonProps = {
  count: number;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
} & (WithConfirm | WithoutConfirm);

const DeleteButton = (props: DeleteButtonProps) => {
  const {
    count,
    label,
    onClick,
    withConfirm = false,
    disabled = false,
    loading = false,
  } = props;

  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <Tooltip title={t("Delete")} arrow>
        <span>
          <ActionBarButton
            startIcon={<Delete />}
            ignoreLocalization
            disabled={disabled || count === 0}
            onClick={withConfirm ? () => setOpen(true) : onClick}
            label={label}
            loading={loading}
          />
        </span>
      </Tooltip>
      {props.withConfirm && (
        <ConfirmDialog
          {...props.ConfirmDialogProps}
          onConfirm={() => {
            setOpen(false);
            onClick();
          }}
          onClose={() => setOpen(false)}
          open={open}
        />
      )}
    </Fragment>
  );
};

export default DeleteButton;
